var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image"},[(_vm.overlay)?_c('div',{staticClass:"image__overlay",class:_vm.$store.request.flipped ? 'image__overlay--flipped' : ''},[_c('img',{attrs:{"src":_vm.overlay}})]):_vm._e(),_c('img',{attrs:{"src":_vm.image}})])}
var staticRenderFns = []

export { render, staticRenderFns }